import axios from 'axios'

const instance = axios.create({
  baseURL: 'http://116.211.118.70:55013/Web_WebService.asmx',
  // baseURL: 'http://localhost:54906/Web_WebService.asmx',
  timeout: 5000,
  transformRequest: [
    function (data) {
      let ret = ''
      // let ret = "identify" + "=" + identity + "&" + data
      for (const it in data) {
        ret += it + '=' + encodeURIComponent(data[it]) + '&'
      }
      ret += 'identify' + '=' + btoa('LOGIN')

      return ret
      // let ret = qs.stringify(data)
    }

  ],
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// instance.interceptors.request.use(
//   (config) => {
//     if (store.getters['user/accessToken']) {
//       config.headers[tokenName] = store.getters['user/accessToken']
//     }
//     //这里会过滤所有为空、0、false的key，如果不需要请自行注释
//     if (config.data)
//       config.data = Vue.prototype.$baseLodash.pickBy(
//         config.data,
//         Vue.prototype.$baseLodash.identity
//       )
//     if (
//       config.data &&
//       config.headers['Content-Type'] ===
//         'application/x-www-form-urlencoded;charset=UTF-8'
//     )
//       config.data = qs.stringify(config.data)
//     if (debounce.some((item) => config.url.includes(item)))
//       loadingInstance = Vue.prototype.$baseLoading()
//     return config
//   },
//   (error) => {
//     return Promise.reject(error)
//   }
// )
instance.interceptors.response.use(
  (response) => {
    const { data } = response
    const { CODE, MSG, DATA } = data
    // 是否操作正常
    // console.log(DATA)
    return DATA
  }
)
export default instance



// WEBPACK FOOTER //
// ./src/utils/request.js